import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

interface Props {
  isSelect?: boolean;
  disabled?: boolean;
}
const CalendarTimeButton: React.FC<Props> = ({
  isSelect,
  disabled,
  children,
}) => {
  return (
    <StyledTimeButton disabled={disabled} isSelect={isSelect}>
      {children}
    </StyledTimeButton>
  );
};

const StyledTimeButton = styled.div<Props>`
  background: ${({ isSelect, disabled }) =>
    isSelect
      ? theme.colors.mainPrimary8
      : disabled
      ? theme.colors.gray9
      : "none"};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${({ isSelect, disabled }) =>
    isSelect
      ? theme.colors.mainPrimary3
      : disabled
      ? theme.colors.gray6
      : theme.colors.gray1};
  align-items: center;
  border: 1px solid
    ${({ isSelect, disabled }) =>
      isSelect
        ? theme.colors.mainPrimary3
        : disabled
        ? theme.colors.gray9
        : theme.colors.gray6};
  padding: 8px 10px;
  gap: 10px;
  width: 56px;
  cursor: pointer;
`;
export default CalendarTimeButton;
